import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/partner/contact";

/**
 * 联系人接口（联系人列表 / 联系人概况）
 *
 * 联系人是客户的联系人，数据和客户详情页「联系人」子表单是同一份（同表的 data_level=2 行），
 * 只是换了个维度看。列表与概况同属「联系人」这一个业务，共用本文件。
 */
export default {
    /** 分页查询联系人列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 保存联系人（新增/编辑） */
    saveContact: (data) => axios.post({url: `${PREFIX_URI}/saveContact`, data}),
    /** 删除联系人 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 查询联系人概况：KPI + 职位分布 + 增长趋势 + 关键决策人 TOP10 */
    overview: (data) => axios.get({url: `${PREFIX_URI}/overview`, data}),
}
